var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex justify-center items-center flex-shrink-0 overflow-hidden text-sm font-medium text-pure-white",
      class: [
        _vm.isActive ? "bg-green-lime" : "bg-light-purple-200",
        _vm.square ? "rounded" : "rounded-full"
      ],
      style: _vm.avatar()
    },
    [
      _vm.avatarUrl == "" || _vm.avatarUrl == null
        ? _c(
            "div",
            { staticClass: "capitalize", style: { fontSize: _vm.fontSize } },
            [_vm._v("\n    " + _vm._s(_vm.getInitial) + "\n  ")]
          )
        : _c("img", {
            staticClass: "rounded-full",
            style: _vm.avatarThumb(),
            attrs: { src: _vm.avatarUrl, alt: "avatar" }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5811d9ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5811d9ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = null
// module chunks = 